export default "__VITE_ASSET__B1vG79yz__"